<template>
    <div>
        <template v-if="Object.keys(service.custom).length > 0">
            <h3>System Details</h3>
            <div class="row">
                <div class="col">
                    <div class="sau-bx p-6">
                        <div class="row">
                            <div v-for="(val, key) in this.col1" :key="key" class="col-sm-12 col-md-6 my-2">
                                <div class="sau-border-bottom pb-2">
                                    <h5>{{ val[0] }}
                                        <button v-b-modal.ip-modal v-if="val[0].includes('ip') || val[0].includes('IP')" class="btn btn-primary float-right text-white py-1" style="font-size: 0.8rem;">View</button>
                                    </h5>
                                    <p class="mb-0">{{ val[1] }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <licensing></licensing>

                <b-modal id="ip-modal"
                        centered
                        title="IP Addresses"
                        hide-footer
                        cancel-variant="link"
                        ref="modalEditIp">
                        <div class="row">
                            <div class="col">

                                <template v-if="service.ipaddress">
                                    <h5>Primary IP:</h5>
                                    <p>{{ service.ipaddress }}</p>
                                </template>

                                <template v-if="service.assignedips">
                                    <h5>Assigned IP's:</h5>
                                    <p class="mb-0" v-for="(ip, index) in filteredIps" :key="index">{{ ip }}</p>
                                </template>

                                <template v-if="!service.ipaddress && !service.assignedips">
                                    <h5>No IP addresses found</h5>
                                </template>

                            </div>
                        </div>
                </b-modal>

            </div>
        </template>
    </div>
</template>

<script>
import Licensing from '../Licensing';
export default {
    components: {
        'licensing': Licensing,
    },
    props: ['service'],
    data() {
        return {
            col1: [],
            col2: [],
        }
    },
    created() {
        this.formatDetails();
    },
    methods: {
        formatDetails() {
            _.forIn(this.service.custom, function(val, key) {
                this.col1.push([key, val]);
            }.bind(this));
        },
    },
    computed: {
        filteredIps() {
            return this.service.assignedips.replace(/[\n\r]+/g, ' ').split(' ').filter(ip => ip != '');
        }
    }
}
</script>

<style lang="scss">
    #ip-modal {
        .row {
            max-height: 50vh;
            overflow-y: scroll;
        }
    }
    .sau-border-bottom {
        border-bottom: solid 1px #e5e5e5;
    }
</style>
